import _ from "lodash";
import {
  columnIds,
  filterIds,
} from "GenericTableEditor/GenericTableEditorUtils";
import { fontStyle, colors } from "Constants";
import update from "immutability-helper";
import { MULTI_LEVEL } from "Fields/FieldUtils";
import { multiLineEllipsis } from "Utils";

const PLANNER_ELEMENT_SET_PROPERTIES_AND_NODE_EDITOR_COLUMNS_CONFIG_MAPPING = {
  allowCodes: {
    columnId: columnIds.code,
    columnLabel: "scopeAndSequence:code",
    style: {
      flex: 0.25,
      ...multiLineEllipsis({ lineHeight: "20px" }),
    },
  },
  allowGrades: {
    columnId: columnIds.grades,
    columnLabel: "scopeAndSequence:grades",
    style: {
      flex: 0.35,
      ...multiLineEllipsis({ lineHeight: "20px" }),
    },
    sequence: 2,
  },
  allowTags: {
    columnId: columnIds.tags,
    columnLabel: "scopeAndSequence:tags",
    style: {
      flex: 0.25,
      ...multiLineEllipsis({ lineHeight: "20px" }),
    },
    sequence: 3,
  },
};

export const getPlannerElementNodeEditorConfig = ({
  plannerElementSetConfig,
  isForPreview,
}) => {
  const initialNodeEditorConfig = {
    columns: [
      {
        id: isForPreview
          ? columnIds.previewSelectableLabel
          : columnIds.selectableLabel,
        sequence: 0,
        label: "common:list_item_other",
        showCheckbox: true,
        customTextStyles: {
          ...fontStyle.medium,
          color: colors.textDefault,
          fontSize: "1.6rem",
          lineHeight: "2.4rem",
        },
        style: {
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        variant: MULTI_LEVEL,
        truncateText: true,
      },
    ],
    tableStyle: {
      minWidth: "auto",
    },
  };

  const updatedNodeEditorConfig = _.reduce(
    plannerElementSetConfig,
    (result, propertyConfig) => {
      const { config, value } = propertyConfig;
      if (value === true) {
        const {
          columnId,
          columnLabel,
          style,
          sequence,
        } = PLANNER_ELEMENT_SET_PROPERTIES_AND_NODE_EDITOR_COLUMNS_CONFIG_MAPPING[
          config
        ];
        return update(result, {
          columns: (columns = []) => [
            ...columns,
            {
              id: columnId,
              label: columnLabel,
              sequence,
              style,
            },
          ],
        });
      }

      return result;
    },
    initialNodeEditorConfig
  );
  return updatedNodeEditorConfig;
};

export const getPlannerElementNodeEditorConfigForNestedChecklist = ({
  plannerElementSetConfig,
  isForPreview = false,
}) => {
  const nodeEditorConfig = getPlannerElementNodeEditorConfig({
    plannerElementSetConfig,
    isForPreview,
  });
  return {
    ...nodeEditorConfig,
    allowedFilters: ["SEARCH_TEXT"],
    showSidebar: true,
    maxNodeDepthForSidebar: 1,
  };
};

export const getFiltersInitialValue = ({ grades }) => {
  return {
    [filterIds.grades]: grades,
  };
};
